import React from "react";

// ServeOn animated logo mark — a swirl with a centered location pin
// Built as inline SVG so it's crisp at any size and themable.
export const LogoMark = ({ size = 40, className = "", animated = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="ServeOn"
  >
    <defs>
      <linearGradient id="so-blue-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1E5A9E" />
        <stop offset="100%" stopColor="#0A2B4E" />
      </linearGradient>
      <linearGradient id="so-orange-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FF8B3A" />
        <stop offset="100%" stopColor="#FF4D00" />
      </linearGradient>
    </defs>
    {/* Outer swirl ring */}
    <g className={animated ? "so-logo-spin" : ""} style={{ transformOrigin: "32px 32px" }}>
      <path
        d="M32 6 a26 26 0 1 1 -18.38 7.62"
        fill="none"
        stroke="url(#so-blue-grad)"
        strokeWidth="7"
        strokeLinecap="round"
      />
    </g>
    {/* Centered pin/dot */}
    <circle cx="32" cy="32" r="9" fill="url(#so-orange-grad)" />
    <circle cx="32" cy="32" r="3.2" fill="#fff" />
    {/* Rocket trail */}
    <path d="M48 16 l8 -8 l-2 6 l-6 2 z" fill="url(#so-orange-grad)" />
  </svg>
);

export const Logo = ({ size = 36, withText = true, className = "" }) => (
  <div className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <LogoMark size={size} />
    {withText && (
      <span className="font-bold text-2xl tracking-tight leading-none">
        <span style={{ color: "var(--so-text)" }}>Serve</span>
        <span style={{ color: "var(--so-orange)" }}>On</span>
      </span>
    )}
  </div>
);

export default Logo;
